<template>
  <div class="hotel-card">
    <div class="ws-textbox">
      <div class="galary-item">
        <div class="carousel slide" data-ride="carousel">
          <div class="carourel_hotel">
            <carousel
              :per-page="1"
              :pagination-enabled="false"
              loop
              :mouse-drag="false"
              autoplay
              :autoplay-timeout="5000"
              :autoplay-hover-pause="true"
            >
              <template
                v-if="
                  hotelInfo.image1_url ||
                  hotelInfo.image2_url ||
                  hotelInfo.image3_url ||
                  hotelInfo.img1 ||
                  hotelInfo.img2 ||
                  hotelInfo.img3
                "
              >
                <slide v-if="hotelInfo.image1_url || hotelInfo.img1">
                  <img :src="hotelInfo.image1_url || hotelInfo.img1" @error="imgDefault" />
                </slide>
                <slide v-if="hotelInfo.image2_url || hotelInfo.img2">
                  <img :src="hotelInfo.image2_url || hotelInfo.img2" @error="imgDefault" />
                </slide>
                <slide v-if="hotelInfo.image3_url || hotelInfo.img3">
                  <img :src="hotelInfo.image3_url || hotelInfo.img3" @error="imgDefault" />
                </slide>
              </template>
              <slide v-else>
                <img :src="hotelImageDefault" />
              </slide>
            </carousel>
          </div>
        </div>
      </div>
      <div v-if="!isAfter" class="content__before">
        <div class="content">
          <div class="hotel-distance pb-1" style="font-size: 16px">
            <span
              v-if="
                hotelInfo.distance || hotelInfo.distance == 0 || hotelInfo.distance_between || hotelInfo.distance_between == 0
              "
            >
              <template v-if="getOptionTaxi && getOptionTaxi === 'from the airport'">
                {{ formatDistance(hotelInfo.distance_from_airport) }}
              </template>
              <template v-else>
                {{ formatDistance(hotelInfo.distance || hotelInfo.distance_between) }}
              </template>
              KM
              <span v-if="!getOptionTaxi"> from the airport </span>
              <span v-else>
                {{ getOptionTaxi }}
              </span>
            </span>
            <span v-else-if="!hotelInfo.distance || !hotelInfo.distance_between" class="ml-2">Unknown</span>
            <div v-if="isShowGGMap" class="pick-up-time mt-3">
              <h2 style="font-size: 20px; color: #474747 !important; font-weight: 400 !important">
                {{ lang.taxi['SFS_LANG_BOOK_TAXI_9'] }}
              </h2>
              <PickUpTime
                :pick-up-title="pickUpTitle"
                @changePreferedTimePickUp="handlePickTime"
                @changePickUpState="changePickUpState"
              ></PickUpTime>
            </div>
          </div>
          <div v-if="sortDescription" class="hotel-description" v-html="hotelInfo.description_en_GB"></div>
        </div>
        <div class="hotel-horizontal mt-3"></div>
        <div v-if="!isShowGGMap">
          <div class="hotel-button-see-more">
            <a href="javascript:" @click="sortDescription = !sortDescription">
              {{ lang['hotellist_mobile_new'].SFS_LANG_ROW_3 }}
            </a>
          </div>
          <div class="hotel-button-select">
            <a href="javascript:" class="btn btn-select" @click="handleBookHotel()">
              {{ lang['hotellist_mobile_new'].SFS_LANG_ROW_4 }}
            </a>
          </div>
        </div>
        <div v-if="isShowGGMap" class="hotel-map text-center">
          <div>
            <a href="javascript:" class="hotel-button-see-more map-show" @click="isSeeMoreShowMap = !isSeeMoreShowMap">{{
              !isSeeMoreShowMap ? 'Show map' : 'Hide map'
            }}</a>
          </div>
          <div v-if="isSeeMoreShowMap" class="map">
            <div>
              <WalkingMap :origin="origin" :is-show-map="isShowMap" :destination="destination" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="isAfter" class="content__after">
        <div class="content">
          <div class="content__hotel-info">
            <div class="hotel-information">
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_2 }}:</span>
                <span :title="getAddressHotel" class="text-truncate">
                  <a :href="'http://maps.google.com/?q=' + getAddressHotel" target="_blank">
                    {{ getAddressHotel }}
                  </a>
                </span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_3 }}:</span>
                <span class="text-truncate">
                  <a :href="'tel:' + hotelInfo.telephone" class="phone-number">{{ hotelInfo.telephone }}</a>
                </span>
              </div>
              <div v-if="checkDate" class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_4 }}:</span>
                <span class="text-truncate"> between {{ timeOpenClose.open_time }} and {{ timeOpenClose.close_time }}</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_5 }}:</span>
                <span class="text-truncate">{{ hotelInfo.num_day }}</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_6 }}:</span>
                <span v-if="hotelInfo.room_type == 1" class="text-truncate">Single room</span>
                <span v-else-if="hotelInfo.room_type == 2" class="text-truncate">Double room</span>
                <span v-else-if="hotelInfo.room_type == 3" class="text-truncate">Triple room</span>
                <span v-else-if="hotelInfo.room_type == 4" class="text-truncate">Quad room</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_7 }}:</span>
                <span class="text-truncate">{{ hotelInfo.voucher_id }}</span>
              </div>
              <div v-if="hotelInfo.ws_reference" class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_9 }}:</span>
                <span class="text-truncate">{{ hotelInfo.ws_reference }}</span>
              </div>
              <div v-else class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_8 }}:</span>
                <span class="text-truncate">{{ hotelInfo.blockcode }}</span>
              </div>
              <div class="d-flex">
                <span class="prefix mr-1">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_10 }}:</span>
                <span class="text-truncate">{{ hotelInfo.ws_reference ? 'HRS' : 'SFS360' }}</span>
              </div>
            </div>
            <div v-if="isCheckBlockDate" class="shuttle-bus-infor">
              <div class="prefix">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_11 }} {{ flightDate || 'Today' }}</div>
              <div v-for="(blockDate, index) in getBlockDate" :key="index">
                <span v-if="blockDate.operating_opentime && blockDate.operating_closetime" class="mr-4">
                  {{ blockDate.operating_opentime }} - {{ blockDate.operating_closetime }}
                </span>
                <span v-if="blockDate.frequency_service"> every {{ blockDate.frequency_service }} min </span>
              </div>
            </div>
            <router-link
              v-if="showCancelHotel && hasCancelHotelVoucher"
              class="text-cancel-hotel pt-3 cursor-pointer"
              :to="{ name: 'CancelHotelRoom', query: { secret: secret, ctime: cancelTime } }"
            >
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_12 }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import WalkingMap from '@/components/Map/index'
import PickUpTime from '@/components/PickUpTime/index'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'HotelCard',
  components: {
    WalkingMap,
    PickUpTime
  },
  props: {
    hotelInfo: {
      type: Object,
      default: () => {}
    },
    isShowGGMap: {
      type: Boolean,
      default: false
    },
    isAfter: {
      type: Boolean,
      default: false
    },
    cancelTime: {
      type: String,
      default: ''
    },
    showCancelHotel: {
      type: Boolean,
      default: false
    },
    hasCancelHotelVoucher: {
      type: Boolean,
      default: false
    },
    origin: {
      type: Object,
      default: () => {}
    },
    destination: {
      type: Object,
      default: () => {}
    },
    timePickup: {
      type: Object,
      default: () => {}
    },
    listDataBooking: {
      type: Array,
      default: () => []
    },
    wayTaxi: {
      type: Number,
      default: 0
    },
    pickUpTitle: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hotelImageDefault: this.$publicPath + 'images/No_Image_Available.jpg',
      sortDescription: false,
      isShowMap: false,
      isSeeMoreShowMap: false,
      day: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      flightDate: '',
      secret: this.$route.query.secret,
      timeOpenClose: {
        open_time: '',
        close_time: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      voucher: 'Taxi/Voucher',
      direction: 'direction'
    }),
    getBlockDate() {
      let shuttleBusInfor = {}
      if (this.isAfter) {
        let blockDate = moment(_.get(this.hotelInfo, 'blockdate', new Date())).format('ddd')
        this.setFlightDate(moment(_.get(this.hotelInfo, 'blockdate', new Date())).format('dddd'))
        let operatingTime = this.hotelInfo['operating_time'] || []
        for (let [index, data] of operatingTime.entries()) {
          if (this.day[index] === blockDate) {
            shuttleBusInfor = data.data
          }
        }
      }
      return shuttleBusInfor
    },
    isCheckBlockDate() {
      if (Array.isArray(this.getBlockDate)) {
        return !this.getBlockDate.every((x) => Object.values(x).every((value) => value === null || value === ''))
      }
      return false
    },
    getAddressHotel() {
      return (
        (this.hotelInfo.address || '') +
        ', ' +
        (this.hotelInfo.zipcode || '') +
        ', ' +
        (this.hotelInfo.city || '') +
        ', ' +
        (this.hotelInfo.country || '')
      )
    },
    getOptionTaxi() {
      let self = this
      if (!self.listDataBooking.length) return ''
      let voucher
      if (self.listDataBooking.length == 1) {
        voucher = self.listDataBooking[0]
      } else {
        voucher = _.find(self.listDataBooking, { type: parseInt(self.wayTaxi) })
      }
      if (
        voucher &&
        voucher.destination &&
        Math.abs(voucher.destination.lat - self.hotelInfo.airport_geo_lat) < 0.001 &&
        voucher &&
        Math.abs(voucher.destination.lng - self.hotelInfo.airport_geo_lon) < 0.001
      ) {
        return 'from the hotel'
      } else {
        return 'from the airport'
      }
    },
    checkDate() {
      if (this.hotelInfo && this.hotelInfo.blockdate) {
        let dateBook = new Date(this.hotelInfo.blockdate)
        let day = dateBook.getDay() //  day = 0 => is sunday, day = 6 => is saturday
        // day in js return sunday with value = 0 and monday with value 1
        // day in db retrun sunday with value = 6 and monday with value 0
        if (day === 0) {
          day = 6
        } else {
          day = day - 1
        }
        if (
          !_.isNull(this.hotelInfo.reception_time.regular[day]) &&
          this.hotelInfo.reception_time.regular[day].open_time &&
          this.hotelInfo.reception_time.regular[day].close_time &&
          this.hotelInfo.reception_time.all_time == 0
        ) {
          this.timeOpenClose.open_time = this.hotelInfo.reception_time.regular[day].open_time
          this.timeOpenClose.close_time = this.hotelInfo.reception_time.regular[day].close_time
          return true
        }
      }
      return false
    }
  },
  mounted() {
    if (this.isAfter) {
      return
    }
    this.isShowMap = this.isShowGGMap
  },
  methods: {
    imgDefault(event) {
      event.target.src = this.hotelImageDefault
    },
    handleBookHotel() {
      this.$emit('handleBookHotel', this.hotelInfo)
    },
    showMap(isShow) {
      this.isShowMap = isShow
    },
    setFlightDate(value) {
      this.flightDate = value
    },
    handlePickTime(value) {
      this.$emit('confirmPickUpTime', value)
    },
    changePickUpState(state) {
      this.$emit('changePickUpState', state)
    },
    formatDistance(number) {
      return parseFloat(number).toFixed(1)
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin important-text {
  line-height: 26pt;
  letter-spacing: -0.3pt;
}

.hotel-card {
  --text-color: #474747;
  .hotel-distance,
  .content__hotel-info {
    font-size: 14pt;
    margin-top: 6pt;
    @include important-text;
    color: var(--text-color);
  }

  .hotel-description {
    padding-bottom: 14pt;
    text-align: justify;
  }

  .btn-select {
    background-color: #0094d5;
    color: #fff;
    font-weight: 400;
    padding-top: 6pt;
    padding-bottom: 6pt;
    border-radius: 20px;
    width: 40%;
  }

  .carourel_hotel img {
    max-width: 100%;
    width: 100%;
    max-height: 100%;
    height: 100%;
  }

  .hotel-horizontal {
    width: 100%;
    height: 1.5px;
    background-color: #ddd;
    border-radius: 10px;
  }

  .hotel-button-select {
    text-align: center;
  }

  .hotel-button-see-more {
    text-decoration: underline;
    color: #999;
    text-align: center;
    margin-bottom: 24pt;
    a {
      color: #999;
    }
  }

  .pick-up-time {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border-radius: 0.75rem;
    margin-bottom: 10px;

    &__value {
      cursor: pointer;
      --font-size: 24pt;
      border: 0 !important;
      height: var(--font-size);
      font-size: var(--font-size);
      color: var(--text-color);
      text-decoration: underline;
      font-weight: 500;
    }
  }

  .content__hotel-info {
    .hotel-information {
      padding-bottom: 2rem;
    }

    .prefix {
      font-weight: 500;
    }

    .text-cancel-hotel {
      opacity: 0.8;
      text-decoration: underline;
      font-size: 13pt;
    }

    a {
      @include important-text;
      text-decoration: underline;
      color: var(--text-color);
    }
  }
}
.map-show {
  font-size: 12px;
  color: #979797;
}
</style>
